import React from 'react'; 
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {RegisterPropsReasign, BulkRegisterPropsReasign} from '../../request.props.js';
import {PresenterRegisterReasign, BulkPresenterRegisterReasign} from '../../../presenter.js'
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'
import { toast } from 'react-toastify';
import SelectQuery from '../../../../component/SelectQuery.js';

export default class ModalReasign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedItem     : this.props.selectedItem,
      ToUser           : "",
      AssetAlias       : null,
      MASTER_USER      : null,
      clicked          : false,
      selectDisabled   : false,
      is_process       : false,
    }
    this.date = new Date()
    this.dontSend = false
    
    this.OnRegisterSuccsess = this.OnRegisterSuccsess.bind(this)
    this.OnRegisterFailed = this.OnRegisterFailed.bind(this)
    this.filterUser = this.filterUser.bind(this);
  }

  // bulk(self, index) {
  //   setTimeout(() => {
  //     const {SelectedItem}  = this.state
  //     let keys = Object.keys(SelectedItem)
  //     if (!index < keys.length) {
  //       BulkPresenterRegisterReasign(
  //         BulkRegisterPropsReasign(self, SelectedItem[keys[index]].Alias , this.OnRegisterSuccsess, this.OnRegisterFailed)
  //       )
  //       this.bulk(self, index + 1)
  //     }
  //   }, 1000)
  // }

  registerReasign(self) {
    const {SelectedItem}  = this.state
    const {bulkMode}  = this.props

    if(bulkMode) {
      for(let i in SelectedItem) {
        BulkPresenterRegisterReasign(
          BulkRegisterPropsReasign(self, SelectedItem[i].Alias , this.OnRegisterSuccsess, this.OnRegisterFailed)
        )
      }
      // this.bulk(self, 0)
    } else {
      PresenterRegisterReasign(
        RegisterPropsReasign(self, this.OnRegisterSuccsess, this.OnRegisterFailed)
      )
    }
    this.setState({is_process: true})
  }

  OnRegisterSuccsess(params, response) {
    this.setState({is_process: false}) 
    toast.success("Success reasign tools");
    params.self.props.closeModal();
    params.self.props.onReassignSuccess(response.data)
  }

  OnRegisterFailed(response) {
    this.setState({is_process: false}) 
    try{
      toast.error(response.data.detail);
    }catch(error){
      console.log(response)
    }
  }

  generateLabel(list, mapping){
    // console.log(list.length)
    try {
      return list.map((val, key) => {
          if(mapping.label === 'Username'){
            val.label = val.FirstName +' '+ val.LastName
          }else{
            val.label = val[mapping.label];
          }
        val.value = val[mapping.value];       
        return val
      }) 
    } catch (error) {       
        if(list !== null){
            let val = []
            val.value = list[mapping.value]
            val.label = list[mapping.label]
            return val  
        }
       return null
    }

  }

  handleUserChange(event) {
    this.setState({
        ToUser: event,
        clicked: true
    })
  }

  filterUser(opt, str, val){
    let opts = opt;
    // if(SelectedItem.hasOwnProperty('NextReservation') && SelectedItem.NextReservation){
    //   if(this.compareDate(this.date, SelectedItem.NextReservation.StartDate)){
    //     opts = opts.filter(
    //       opt => opt.Username === SelectedItem.NextReservation.User.Username || opt.UserType === 'storage'
    //     );
    //   }
    // }
    return opts.filter(opt => opt.Username !== this.props.UserReducer.username)
  }
  
  compareDate(nowDates,comparedDate){
    const compared = new Date(comparedDate)
    return (nowDates >= compared)
  }

  shouldComponentUpdate(nextProps, nextState) { 
    if( nextState.MASTER_USER === null) {
      nextState.MASTER_USER = this.generateLabel(nextProps.userData, {value:'Alias', label:'Username'});
    }
    if(nextProps.selectedItem !== null) {
      nextState.SelectedItem  = nextProps.selectedItem;
      nextState.AssetAlias    = nextProps.selectedItem.Alias;
    }
    
    if(nextState.clicked){
      nextState.clicked = false;
    }
    
    return true; 
  }
  willUnMount(){
    this.setState({
      selectDisabled   : false,
      ToUser : "",
    })
  }

  willMount(){
    let obj = {}
    if(this.props.isPerUser){
      obj.selectDisabled = true
      obj.ToUser = this.props.userData[0].Alias
    }else{
      obj.selectDisabled = false
    }
    this.setState(obj);
  }

  renderAssetField() {
    const {SelectedItem}  = this.state
    if(this.props.bulkMode) {
      let a = []
      for(let i in SelectedItem) {
        a.push(
          <span key={SelectedItem[i].Alias}>
            <input type="text" className="form-control" value={SelectedItem[i].Name} disabled/>
            <input type="hidden" className="form-control" name="asset" id="asset" value={SelectedItem[i].Alias}/>
          </span>
        )
      }
      return(a)
    } else {
      return(
        <span>
          <input type="text" className="form-control" value={SelectedItem.Name} disabled/>
          <input type="hidden" className="form-control" name="asset" id="asset" value={SelectedItem.Alias}/>
        </span>
      )
    }
  }

  renderInfoPeruser() {
    let dataPeruser = this.props.userData

    if(this.props.isPerUser && dataPeruser[0]) {
      return (
        <input 
          type="text" 
          className="form-control"
          value={`${dataPeruser[0].FirstName} ${dataPeruser[0].LastName}`} readOnly />
      )
    }
  }

  render() {

    if (this.state.SelectedItem === null){
      return (null)
    }

    const {SelectedItem, is_process}  = this.state
    const {bulkMode}      = this.props
    const fullName        = this.props.UserReducer.props.first_name+" "+this.props.UserReducer.props.last_name;
    
    return (
      <Modal isOpen={this.props.modalState} onExit={()=>this.willUnMount()} onEnter = {() => this.willMount()} toggle={this.props.closeModal}>
        <ModalHeader toggle={this.props.closeModal}> {bulkMode && 'Bulk '} Reassigned Asset / Tools</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="asset">Asset / Tools</label>
                {this.renderAssetField()}
              </div>
            
              <div className="row">
                <div className="form-group col-sm-6">
                  <label htmlFor="from">From</label>
                  <input type="text" className="form-control" id="from" value={fullName} readOnly/>
                </div>
                <div className="form-group col-sm-6">
                  <label htmlFor="to">To</label>
                  {this.props.isPerUser ? this.renderInfoPeruser() :
                    <SelectQuery 
                    name="ToUser"
                    placeholder="Type Username"
                    value={this.state.ToUser}
                    extra="ordering=Name"
                    urlKey="read-user-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    filterOptions={this.filterUser}
                    onChange={(val)=>this.handleUserChange(val.value)}
                  //  initOption={
                  //    this.props.isPerUser ? this.getInitPerUser() : null
                  //  }
                    UserReducer={this.props.UserReducer}
                    disabled={this.state.selectDisabled}
                  />
                  }
                  <i className="small text-muted">
                    <strong>
                      {SelectedItem.hasOwnProperty('NextReservation') && SelectedItem.NextReservation !== null ? "Next Reservation : " + SelectedItem.NextReservation.User.FirstName + ' ' + SelectedItem.NextReservation.User.LastName : ""}
                    </strong>
                  </i>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={this.props.closeModal}>cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={()=>this.registerReasign(this)}>Reassign</ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/Modal/ModalReasign.js